export default __webpack_public_path__ + "static/media/ref-poczta-polska.b7170ee7.pdf";